import React from "react";
import { Box, Dialog, Typography } from "@mui/material";
import { YSButton } from "../../../uikit/YSButton";
import { BtnGroupWAStyle, primaryColor } from "../../../Theme";
import {
  AGENTIC_RX_PATH,
  NEW_RX_PATH,
  RxExperiencePath,
  RxExperiencePrompt,
  getRxExperienceLabel,
} from "../../../utils/AIPrescription/rxExperiencePreference";

interface RxExperiencePreferenceDialogProps {
  open: boolean;
  mode: RxExperiencePrompt | null;
  currentPath: RxExperiencePath | null;
  existingDefault: RxExperiencePath;
  onChoose: (path: RxExperiencePath) => void;
  onConfirmChange: () => void;
  onKeepExisting: () => void;
}

const RxExperiencePreferenceDialog: React.FC<RxExperiencePreferenceDialogProps> = ({
  open,
  mode,
  currentPath,
  existingDefault,
  onChoose,
  onConfirmChange,
  onKeepExisting,
}) => {
  const newLabel = currentPath ? getRxExperienceLabel(currentPath) : "this experience";
  const currentDefaultLabel = existingDefault
    ? getRxExperienceLabel(existingDefault)
    : "your current default";

  return (
    <Dialog
      open={open}
      onClose={mode === "confirm" ? onKeepExisting : undefined}
      disableEscapeKeyDown={mode === "choose"}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          p: { xs: 2, sm: 2.5 },
        },
      }}
    >
      {mode === "choose" && (
        <Box>
          <Typography
            component="h2"
            sx={{ fontWeight: 700, fontSize: "1.05rem", color: primaryColor, mb: 1 }}
          >
            Choose your default Rx experience
          </Typography>
          <Typography component="p" sx={{ fontSize: "0.9rem", lineHeight: 1.45, mb: 2.5 }}>
            You can prescribe with AgenticRx or New Rx Pad. Which should open first when you
            access Rx?
          </Typography>
          <BtnGroupWAStyle>
            <YSButton
              children="AgenticRx"
              variant="contained"
              type="button"
              onClick={() => onChoose(AGENTIC_RX_PATH)}
              size="medium"
            />
            <YSButton
              children="New Rx Pad"
              variant="outlined"
              type="button"
              onClick={() => onChoose(NEW_RX_PATH)}
              size="medium"
            />
          </BtnGroupWAStyle>
        </Box>
      )}

      {mode === "confirm" && (
        <Box>
          <Typography
            component="h2"
            sx={{ fontWeight: 700, fontSize: "1.05rem", color: primaryColor, mb: 1 }}
          >
            Make {newLabel} your default?
          </Typography>
          <Typography component="p" sx={{ fontSize: "0.9rem", lineHeight: 1.45, mb: 2.5 }}>
            You switched to {newLabel}. Set it as your default Rx experience instead of{" "}
            {currentDefaultLabel}? You can change this later by switching pads again.
          </Typography>
          <BtnGroupWAStyle>
            <YSButton
              children="Not now"
              variant="outlined"
              type="button"
              onClick={onKeepExisting}
              size="medium"
            />
            <YSButton
              children="Set as default"
              variant="contained"
              type="button"
              onClick={onConfirmChange}
              size="medium"
            />
          </BtnGroupWAStyle>
        </Box>
      )}
    </Dialog>
  );
};

export default RxExperiencePreferenceDialog;
